import Socket from '@flipster/socket/Socket';
import SocketPingPongPlugin from '@flipster/socket/SocketPingPongPlugin';
import { V2SocketEvents } from '@flipster/socket/r230522/socket';
import { getServerHostname } from '@flipster/utils/env-helper';

import { NormalToFixedR230522Socket } from '../normal-sub';

// Webview 빌드시에 page prerendering이 되면서 `getServerHostname`이 빈 문자열을 반환할 수 있음.
// URL 생성자에 들어가는 인자는 올바른 URL이어야 함.
// 실제로 사용되지는 않으므로 invalid를 사용.
const baseUrl = new URL(getServerHostname() || 'http:invalid');
baseUrl.protocol = baseUrl.protocol === 'http:' ? 'ws:' : 'wss:';

export function createPublicR230522Socket() {
  const publicR230522Url = new URL('/api/v2/stream/r230522-public', baseUrl);
  return new Socket<V2SocketEvents>(publicR230522Url, 'r230522-public', [SocketPingPongPlugin]);
}

export function createPrivateR230522Socket() {
  const privateR230522Url = new URL('/api/v2/stream/r230522', baseUrl);
  return new Socket<V2SocketEvents>(privateR230522Url, 'r230522-private', [SocketPingPongPlugin]);
}

export function createPublicN2FR230522Socket() {
  const publicSubscriptionR230522Url = new URL('/api/v2/stream/r230522-public?mode=subscription', baseUrl);
  const normalR230522 = new Socket<V2SocketEvents>(publicSubscriptionR230522Url, 'r230522-subscription-public', [
    SocketPingPongPlugin,
  ]);
  return new NormalToFixedR230522Socket(normalR230522, 'n2f-r230522-public');
}

export function createPrivateN2FR230522Socket() {
  const privateSubscriptionR230522Url = new URL('/api/v2/stream/r230522?mode=subscription', baseUrl);
  const normalR230522 = new Socket<V2SocketEvents>(privateSubscriptionR230522Url, 'r230522-subscription-private', [
    SocketPingPongPlugin,
  ]);
  return new NormalToFixedR230522Socket(normalR230522, 'n2f-r230522-private');
}
